angular.module('resourceCenterMaterialModule').value('materialConst', {
    // 素材状态映射
    statusMap: {
        '0': '审核中',
        '-1': '审核失败',
        '1': '转码完成',
        '10': '转码中',
        '-10': '转码失败', 
        '-20': '快编中',
        '30': '拆条中',
        '-30': '拆条失败'
    },
    // 素材类型字典表
    materialTypeDictionary: {
        0: '图片',
        1: '音频',
        2: '视频',
        3: '文字'
    },
    // 媒资库权限模型参数映射
    modelNameMap: {
        personal: '个人素材库',
        edited: '已编素材库',
        share: '共享素材库',
        meizi: '媒资素材库',
    },
    // 媒资库权限素材库类型与一级类映射
    classMap: {
        personal: 'personalmaterial',
        edited: 'editedmaterial',
        share: 'sharedmaterial',
        meizi: 'mzmaterial',
    },
    // 媒资库权限资源类型与二级分类映射
    classifyMap: {
        '0': 'pics',
        '2': 'videos',
        '1': 'audios',
        '3': 'words',
    },
    // 素材时长与名称映射
    materialDuration: [
        {
            value: '',
            name: '全部',
        },
        {
            value: '(0,30]',
            name: '30秒内',
        },
        {
            value: '(30,60]',
            name: '30-60秒',
        },
        {
            value: '(60,300]',
            name: '1-5分钟',
        },
        {
            value: '(300,∞)',
            name: '5分钟以上',
        },
    ],
    // 素材版权类型映射
    versionInfo: [
        {
            value: '',
            name: '全部',
        },
        {
            value: 1,
            name: '原创',
        },
        {
            value: 0,
            name: '转载',
        },
    ],
    // 素材审核状态映射
    statusType: [
        {
            value: '',
            name: '全部',
        },
        {
            value: '1',
            name: '审核合格',
        },
        {
            value: '-1',
            name: '审核不合格',
        },
        {
            value: '0',
            name: '审核中',
        },
    ],
    // 日期范围定义
    timeRange: [
        {
            value: '1d',
            label: '一天内',
        },
        {
            value: '7d',
            label: '一周内',
        },
        {
            value: '1m',
            label: '一月内',
        },
        {
            value: 'any',
            label: '自定义时间',
        },
    ],
    // 音视频码率映射
    bitRate: [
        {
            value: '',
            name: '全部',
        },
        {
            value: '480',
            name: '普通',
        },
        {
            value: '720',
            name: '标清',
        },
        {
            value: '1080',
            name: '高清',
        },
        {
            value: '2160',
            name: '4k超清',
        },
        {
            value: '4320',
            name: '8k极致',
        },
        {
            value: 'other',
            name: '其他',
        },
    ],
    // 素材来源映射
    sourceList: [
        {
            value: '',
            name: '全部来源',
        },
        {
            value: 'upload',
            name: '个人上传',
        },
        {
            value: 'product',
            name: '成品稿库',
        },
        {
            value: 'edited',
            name: '已编素材',
        },
        {
            value: 'guangdian',
            name: '广电',
        },
    ],
    // 来源中成品资源库中的全部渠道
    channels: [
        {
            name: '全部',
            value: '',
        }, {
            name: '电视',
            value: 'tv',
        }, {
            name: '广播',
            value: 'broadcast',
        }, {
            name: '客户端',
            value: 'app',
        }, {
            name: '微信',
            value: 'wechat',
        }, {
            name: '微博',
            value: 'weibo',
        }, {
            name: '头条',
            value: 'toutiao',
        }, {
            name: '抖音',
            value: 'douyin',
        }, {
            name: '企鹅号',
            value: 'qiehao',
        }, {
            name: '数字报刊',
            value: 'szb',
        }, {
            name: '网站',
            value: 'wz',
        }, {
            name: '百家号',
            value: 'baijiahao',
        },
    ],
    // 获取图片类型(横图还是竖图)
    imgType: [
        {
            value: '',
            name: '全部',
        },
        {
            value: '竖图',
            name: '竖图',
        },
        {
            value: '横图',
            name: '横图',
        },
    ],
    // 获取图片尺寸规格映射
    imgSize: [
        {
            value: '',
            name: '全部',
        },
        {
            value: '小尺寸',
            name: '小尺寸',
        },
        {
            value: '中尺寸',
            name: '中尺寸',
        },
        {
            value: '大尺寸',
            name: '大尺寸',
        },
        {
            value: '超大尺寸',
            name: '超大尺寸',
        },
    ],
    allStatusMap: {
        auditing: {
            name: '审核中',
            value: 0,
        },
        formating: {
            name: '转码中',
            value: 10,
        },
        success: {
            name: '审核成功',
            value: 1,
        },
        auditFail: {
            name: '审核失败',
            value: -1,
        },
        formatFail: {
            name: '转码失败',
            value: -10,
        },
        fastEditing: {
            name: '快编中',
            value: -20,
        },
        spliting: {
            name: '拆条中',
            value: 30,
        },
        splitFail: {
            name: '拆条失败',
            value: -30,
        }
    }, 
    keywordsTypeList: [
        {
            name: '关键词',
            value: 'keywords',
        },
        {
            name: '标签',
            value: 'tag',
        },
    ]
});
